{
  "pt": {
    "sortGroups": {
      "date": "Data",
      "deadline": "Prazo",
      "name": "Nome"
    },
    "sorting": {
      "category_name_asc": "Categoria A → Z",
      "category_name_desc": "Categoria Z → A",
      "created_at_asc": "Mais antigo criado primeiro",
      "created_at_desc": "Mais recente criado primeiro",
      "deadline_date_asc": "Prazo mais recente primeiro",
      "deadline_date_desc": "Prazo mais antigo primeiro",
      "due_date asc": "Prazo mais recente primeiro",
      "due_date desc": "Prazo mais antigo primeiro",
      "group_name asc": "Nome A → Z",
      "group_name desc": "Nome Z → A",
      "group_name_asc": "Nome A → Z",
      "group_name_desc": "Nome Z → A",
      "last_name_asc": "Sobrenome A → Z",
      "last_name_desc": "Sobrenome Z → A",
      "messaged_all_at_nulls_first_asc": "Mais antigo primeiro",
      "messaged_all_at_nulls_last_desc": "Mais recente primeiro",
      "messaged_at_nulls_first_asc": "Mais antigo primeiro",
      "messaged_at_nulls_last_desc": "Mais recente primeiro",
      "name_asc": "Nome A → Z",
      "name_desc": "Nome Z → A",
      "name_lower asc": "Nome A → Z",
      "name_lower desc": "Nome Z → A",
      "name_lower_asc": "Nome A → Z",
      "name_lower_desc": "Nome Z → A",
      "notification_level_name_asc": "Unidade A → Z",
      "notification_level_name_asc_sup": "Projeto A → Z",
      "notification_level_name_desc": "Unidade Z → A",
      "notification_level_name_desc_sup": "Projeto Z → A",
      "session_started_at_asc": "Sessão mais antiga primeiro",
      "session_started_at_desc": "Sessão mais recente primeiro",
      "status asc": "Status A → Z",
      "status desc": "Status Z → A",
      "status_name_asc": "Status A → Z",
      "status_name_desc": "Status Z → A",
      "unit_name_asc": "Unidade A → Z",
      "unit_name_desc": "Unidade Z → A",
      "unit_name_lower_asc": "Unidade A → Z",
      "unit_name_lower_desc": "Unidade Z → A",
      "updated_at asc": "Mais antigo atualizado primeiro",
      "updated_at desc": "Mais recente atualizado primeiro",
      "updated_at_asc": "Mais antigo atualizado primeiro",
      "updated_at_desc": "Mais recente atualizado primeiro"
    }
  }
}
